/**
 * Demanda 240 — mensagens de reserva pendente exibidas ao cliente (seção 5).
 *
 * A tela de processamento tinha um texto único. A demanda separa em três, e o
 * que muda não é estética: cada texto comunica uma expectativa de prazo
 * diferente, e a errada gera chamado no Fale Conosco.
 *
 * Os textos são os do documento funcional, transcritos literalmente.
 */

export const BOOKING_PROCESSING_GROUPS = {
	/** CREATION, QUOTATION, PROCESSING, EMISSION, EDITION — resposta em minutos. */
	EM_ANDAMENTO: "EM_ANDAMENTO",
	/** ORDER, ON_REQUEST, WAITING_LIST, ANALYSIS, INCONSISTENT — pode levar horas. */
	ESPERANDO_TERCEIRO: "ESPERANDO_TERCEIRO",
	/** Status fora dos 21 documentados — não dá para prosseguir. */
	DESCONHECIDO: "DESCONHECIDO",
	/** CANCELED, EXPIRED, DENIED, BLOCKED... — o fornecedor recusou. */
	ENCERRADA_STATUS_FORNECEDOR: "ENCERRADA_STATUS_FORNECEDOR",
};

const CONCIERGE = "Em caso de dúvida, entre em contato com o nosso Concierge digital através dos canais de Fale Conosco.";

const MENSAGENS = {
	[BOOKING_PROCESSING_GROUPS.EM_ANDAMENTO]: {
		titulo: "Sua reserva está sendo processada",
		texto: CONCIERGE,
		emFalha: false,
	},
	[BOOKING_PROCESSING_GROUPS.ESPERANDO_TERCEIRO]: {
		titulo: "Sua reserva está sendo processada",
		texto:
			"A confirmação pode levar algumas horas. Assim que tivermos uma resposta, avisaremos por e-mail. " +
			CONCIERGE,
		emFalha: false,
	},
	[BOOKING_PROCESSING_GROUPS.DESCONHECIDO]: {
		titulo: "Não foi possível confirmar sua reserva",
		texto:
			"O sistema do nosso parceiro não conseguiu confirmar sua reserva, por isso não será possível prosseguir. " +
			"Procure o Concierge através do Fale Conosco.",
		emFalha: true,
	},
};

/*
 * A spec só define texto de falha para o status desconhecido. Para o status
 * terminal do fornecedor vale o mesmo aviso: a reserva não vai acontecer e o
 * cliente precisa procurar o Concierge — mostrar "sendo processada" seria falso.
 */
MENSAGENS[BOOKING_PROCESSING_GROUPS.ENCERRADA_STATUS_FORNECEDOR] = MENSAGENS[BOOKING_PROCESSING_GROUPS.DESCONHECIDO];

/**
 * Mensagem do grupo. Sem grupo conhecido, cai em "Em andamento" — é o texto
 * mais neutro e o único que não promete prazo nem anuncia falha.
 */
export const getBookingProcessingMessage = (group) =>
	MENSAGENS[group] || MENSAGENS[BOOKING_PROCESSING_GROUPS.EM_ANDAMENTO];
